import Utils from 'general/utils/Utils';
import axiosClient from './axiosClient';

const agencyBankApi = {
    // lay danh sach ngan hang
    getAgencyBankList: (params = {}) => {
        const url = '/agency/bankAccount/all';
        return axiosClient.get(url, { params: Utils.filterParams(params) });
    },

    // tao ngan hang
    createAgencyBank: (params) => {
        const url = '/agency/bankAccount/create';
        return axiosClient.post(url, params);
    },

    // cap nhat thong tin ngan hang
    updateAgencyBank: (bankAccountId, params) => {
        const url = `/agency/bankAccount/${bankAccountId}`;
        return axiosClient.put(url, params);
    },

    // xoa ngan hang
    deleteAgencyBank: (bankAccountId) => {
        const url = `/agency/bankAccount/${bankAccountId}`;
        return axiosClient.delete(url);
    },

    // tra cuu tai khoan ngan hang
    lookupAgencyBank: (params) => {
        const url = `/agency/bankAccount/lookup`;
        return axiosClient.post(url, params);
    },
};

export default agencyBankApi;
